export default Object.freeze({
  ONBOARDING: 'ONBOARDING',
  ASSISTED_OPERATIONAL: 'ASSISTED_OPERATIONAL',
  OPERATIONAL: 'OPERATIONAL',
})
